import cx from 'classnames'
import NextImage from 'next/image'

import { getSanityImageLoader } from '@lib/image'

interface BundleSlotHeaderProps {
  slotTitle: string
  selectedVariantTitle?: string
  selectedVariantPhoto?: string | null
}

const BundleSlotHeader = ({
  slotTitle,
  selectedVariantTitle,
  selectedVariantPhoto,
}: BundleSlotHeaderProps) => {
  return (
    <div className="flex items-center justify-between mb-8 min-h-[75px]">
      <div>
        {!!selectedVariantTitle && (
          <p className="text-sm leading-relaxed tracking-wider font-semibold uppercase">
            {selectedVariantTitle}
          </p>
        )}
        <h3 className="font-semibold mb-0 text-2xl">{slotTitle}</h3>
      </div>

      {!!selectedVariantPhoto && (
        <figure
          className={cx(
            'photo-figure',
            'rounded-full overflow-hidden w-[75px] h-[75px]',
          )}
        >
          <NextImage
            src={selectedVariantPhoto}
            loader={getSanityImageLoader}
            width={75}
            height={75}
            quality={75}
            alt=""
            className={cx(
              'block overflow-hidden transition-opacity duration-500',
              'object-cover w-[75px] h-[75px]',
            )}
          />
        </figure>
      )}
    </div>
  )
}

export default BundleSlotHeader
